<div class="app">
  <app-menu *ngIf="auth.isLoggedIn"></app-menu>
  <div class="main-content">
    <router-outlet></router-outlet>
  </div>
  <app-footer *ngIf="auth.isLoggedIn"></app-footer>
</div>
